import React from 'react'
import { Redirect, Switch, useRouteMatch } from 'react-router-dom'
import RestrictedRoute from '../auth/RestrictedRoute'
import CategoryPeriodPage from './CategoryPeriodsPage/CategoryPeriodsPage'
import { ExceptionalSchedulesRoot } from './ExceptionalSchedulesPage/ExceptionalSchedulesPage'
import ExpressCheckoutOpeningHoursPage from './ExpressCheckoutOpeningTimes'
import ExpressCheckoutProductAvailabilitiesPage from './ExpressCheckoutProductAvailabilities'

export default function ExpressCheckoutPage() {
  const match = useRouteMatch()
  const path = match.path
  return (
    <Switch>
      <Redirect exact from={path} to={`${path}/aukioloajat`} />
      <RestrictedRoute
        exact
        requiredPermission='nav_basic'
        path={`${path}/aukioloajat`}
        component={ExpressCheckoutOpeningHoursPage}
      />
      <RestrictedRoute
        requiredPermission='nav_basic'
        path={`${path}/poikkeusaukioloajat`}
        component={ExceptionalSchedulesRoot}
      />
      <RestrictedRoute
        requiredPermission='nav_basic'
        path={`${path}/aukioloajat/:categoryId`}
        component={CategoryPeriodPage}
      />
      <RestrictedRoute
        requiredPermission='nav_basic'
        path={`${path}/tuotesaatavuudet`}
        component={ExpressCheckoutProductAvailabilitiesPage}
      />
    </Switch>
  )
}
